import { Link } from '@tanstack/react-router'
import { Lock } from 'lucide-react'

import { cn } from '@/lib/utils'

export function LockedNotice({
  entityName,
  userManagementEntityId,
  userManagementEntityName,
  serviceAccounts = false,
  className,
}: {
  entityName: string
  userManagementEntityId?: string | null
  userManagementEntityName?: string | null
  serviceAccounts?: boolean
  className?: string
}) {
  const noun = serviceAccounts ? 'service accounts' : 'users'
  return (
    <div className={cn('flex flex-col items-center gap-3 text-center', className)}>
      <Lock className="text-muted-foreground size-7" aria-hidden="true" />
      <h2 className="text-foreground text-sm font-medium">
        {serviceAccounts ? 'Service accounts' : 'Users'} aren't managed at this level
      </h2>
      <p className="text-muted-foreground max-w-md text-xs">
        {entityName} doesn't manage its own {noun}; access is managed higher up in
        the hierarchy.
      </p>
      {userManagementEntityId && userManagementEntityName ? (
        <Link
          to={serviceAccounts ? '/$entityId/service-accounts' : '/$entityId/users'}
          params={{ entityId: userManagementEntityId }}
          className="text-primary text-xs font-medium hover:underline"
        >
          Manage {noun} at {userManagementEntityName}
        </Link>
      ) : null}
    </div>
  )
}
